import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { InvalidOperationError } from "./Error";
import { createNoDashGuid } from "./Guid";
import { Queue } from "./Queue";
export var Stream = /*#__PURE__*/function () {
  function Stream(streamId) {
    var _this = this;

    _classCallCheck(this, Stream);

    this.privReaderIdCounter = 1;
    this.privIsEnded = false;

    this.getReader = function () {
      var readerId = _this.privReaderIdCounter;
      _this.privReaderIdCounter++;
      var readerQueue = new Queue();
      var currentLength = _this.privStreambuffer.length;
      _this.privReaderQueues[readerId] = readerQueue;

      for (var i = 0; i < currentLength; i++) {
        readerQueue.enqueue(_this.privStreambuffer[i]);
      }

      return new StreamReader(_this.privId, readerQueue, function () {
        delete _this.privReaderQueues[readerId];
      });
    };

    this.throwIfClosed = function () {
      if (_this.privIsEnded) {
        throw new InvalidOperationError("Stream closed");
      }
    };

    this.privId = streamId ? streamId : createNoDashGuid();
    this.privStreambuffer = [];
    this.privReaderQueues = {};
  }

  _createClass(Stream, [{
    key: "close",
    value: function close() {
      if (!this.privIsEnded) {
        this.writeStreamChunk({
          buffer: null,
          isEnd: true,
          timeReceived: Date.now()
        });
        this.privIsEnded = true;
      }
    }
  }, {
    key: "writeStreamChunk",
    value: function writeStreamChunk(streamChunk) {
      this.throwIfClosed();
      this.privStreambuffer.push(streamChunk);

      for (var readerId in this.privReaderQueues) {
        if (!this.privReaderQueues[readerId].isDisposed()) {
          try {
            this.privReaderQueues[readerId].enqueue(streamChunk);
          } catch (e) {// Do nothing
          }
        }
      }
    }
  }, {
    key: "isClosed",
    get: function get() {
      return this.privIsEnded;
    }
  }, {
    key: "id",
    get: function get() {
      return this.privId;
    }
  }]);

  return Stream;
}(); // tslint:disable-next-line:max-classes-per-file

export var StreamReader = /*#__PURE__*/function () {
  function StreamReader(streamId, readerQueue, onClose) {
    var _this2 = this;

    _classCallCheck(this, StreamReader);

    this.privIsClosed = false;

    this.read = function () {
      if (_this2.isClosed) {
        throw new InvalidOperationError("StreamReader closed");
      }

      return _this2.privReaderQueue.dequeue().onSuccessContinueWith(function (streamChunk) {
        if (streamChunk === undefined || streamChunk.isEnd) {
          _this2.privReaderQueue.dispose("End of stream reached");
        }

        return streamChunk;
      });
    };

    this.close = function () {
      if (!_this2.privIsClosed) {
        _this2.privIsClosed = true;

        _this2.privReaderQueue.dispose("StreamReader closed");

        _this2.privOnClose();
      }
    };

    this.privReaderQueue = readerQueue;
    this.privOnClose = onClose;
    this.privStreamId = streamId;
  }

  _createClass(StreamReader, [{
    key: "isClosed",
    get: function get() {
      return this.privIsClosed;
    }
  }, {
    key: "streamId",
    get: function get() {
      return this.privStreamId;
    }
  }]);

  return StreamReader;
}();